# app/javascript/partials/gps_extractor.coffee
import exifr from 'exifr'

class GpsExtractor
  constructor: (addressInput, geocoder) ->
    @addressInput = addressInput
    @geocoder = geocoder

  extractAndApply: (file) =>
    exifr.gps(file)
      .then (gps) =>
        if gps?.latitude && gps?.longitude
          @geocodeAndApply gps.latitude, gps.longitude
        else
          @setFromCurrentLocation()
      .catch (error) =>
        @setFromCurrentLocation()

  setFromCurrentLocation: () =>
    return unless 'geolocation' of navigator

    navigator.geolocation.getCurrentPosition ({ coords }) =>
      @geocodeAndApply coords.latitude, coords.longitude

  geocodeAndApply: (lat, lng) =>
    location = { lat, lng }

    @geocoder.geocode { location }, (results) =>
      result = results[0]
      if result
        @addressInput.val(result.formatted_address)
      else
        @addressInput.val('')

export default GpsExtractor
